// Generate object from an array.
const formObjectFromArray = (arr, funcCreateValue) => arr.reduce(
  (current, key) => ({ ...current, ...funcCreateValue(key) }), {},
);

// Multi-leveled object morphed into a single level object for easier processing in ReChart.
// export const aggregateMultiLevelObj = (multiLevelObj) => {
export const aggregateMultiLevelObj = multiLevelObj => multiLevelObj
  && formObjectFromArray(Object.values(multiLevelObj), value => value);

export const processData = ({
  unprocessedData,
  range,
  sum,
  groups,
  rangeOrder,
}) => {
  const { data } = unprocessedData;

  // Create an initial data object for populating the data later.
  // The below function grabs all second-level keys and place it into an array.
  // It can be either a groups/range object defined in config, or define as a column name
  // as a string, to grab all options from a data column.
  const getKeys = defined => (
    (typeof defined === 'string')
      ? [...new Set(data.map(item => item[defined]))] // Grab all options in the column
      : Object.keys(aggregateMultiLevelObj(defined)) // Grab all second-level leaves if is an object
  );

  // Create an object based on the keys provided via above function for groups.
  const chartDataOnlyGroupsObj = formObjectFromArray(getKeys(groups), key => (
    { [key]: null }
  ));

  const chartDataObj = formObjectFromArray(getKeys(range), key => (
    { [key]: { name: key.toString(), ...chartDataOnlyGroupsObj } }
  ));

  // Populate the data into the object. Reverse while loop performs the fastest, thus,
  // is used in here.
  /* eslint no-plusplus: 0 */
  let i = data.length;
  while (i--) {
    const dt = data[i];
    const sumDt = dt[sum];

    // Find objects within groups object, if found either added by appointed "sum" prop or
    // count things via adding the value by 1.
    const process = (rangeDt) => {
      Object.keys(groups).forEach((gItem) => {
        const groupDt = dt[gItem];
        if (chartDataOnlyGroupsObj[groupDt] !== undefined) {
          let chartDataItem = chartDataObj[rangeDt][groupDt];
          if (chartDataItem === null) chartDataItem = 0;
          chartDataItem += sum ? parseFloat(sumDt) : 1;
          chartDataObj[rangeDt][groupDt] = Math.round(chartDataItem * 100) / 100;
        }
      });
    };

    if (typeof range === 'string') {
      process(dt[range]);
    } else {
      Object.keys(range).forEach(rItem => chartDataObj[dt[rItem]] && process(dt[rItem]));
    }
  }

  // The data is map in a particular order defined by rangeOrder, otherwise, use the default
  // version from range.
  let rearrangedChartDataObj;
  if (rangeOrder) {
    rearrangedChartDataObj = rangeOrder.map(item => chartDataObj[item]);
  }

  // Turn object into array for ReChart usage.
  return Object.values(rearrangedChartDataObj || chartDataObj);
};

// Polar chart data requires summing all values within the range.
// If there is no "sum" prop defined, usually is the amount of things.
export const sumDataForSimpleChart = (data, dataKey = 'amount') => {
  // Create a new object.
  const newObj = {};
  if (!data[0]) return [];

  Object.keys(data[0]).forEach((key) => {
    if (typeof data[0][key] === 'number') newObj[key] = 0;
  });

  // Populate the new object and sum the value.
  data.forEach((item, i) => (
    Object.keys(item).forEach((key) => {
      if (typeof data[i][key] === 'number') {
        newObj[key] += item[key];
        newObj[key] = Math.round(newObj[key] * 100) / 100;
      }
    })
  ));

  // Remake the Rechart data for simple chart.
  return Object.keys(newObj).map(name => ({ name, [dataKey]: newObj[name] }));
};
